import React, { useEffect, useState, useMemo } from 'react'
import Navbar from '../shared/Navbar';
import Sidebar from '../shared/Sidebar';
import SettingsPanel from '../shared/SettingsPanel';
import Footer from '../shared/Footer';
import { Styles } from "../../components/styles/nomination";
import { MultiSelect } from "react-multi-select-component";
// import Modal from '../employeeNomination/Modal';
import Modal from '../usersNomination/Modal';
import DataTable from "react-data-table-component";
import FilterDataTable from "../../pages/instructor/FilterDataTable";
import StickyMenu from '../../components/common/StickyMenu'
import { Form, InputGroup, Row, Col, Button, Tooltip, Alert } from 'react-bootstrap';
import service from '../../services/service';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import downloadXlFile from '../usersNomination/bulkUsersRegistrationNomination.xls'
import * as XLSX from 'xlsx'
import UserService from '../../services/UserService';


const BulkUsersRegistrationNomination = () => {

    const ALREADY_NOMINATED = "already nominated";
    const PARTIALLY_NOMINATED = "partially nominated";
    const NOT_NOMINATED = "not nominated";
    const USER_NOT_FOUND = "user not found";
    const dummyData = [
        {
            firstName: "Shovan",
            lastName: "Shovan",
            emailId: "shovank@gmail.com",
            contact: 9999999999
        },
        {
            firstName: "Shovan",
            lastName: "Shovan",
            emailId: "shovank@gmail.com",
            contact: 9999999999
        },
        {
            firstName: "Shovan",
            lastName: "Shovan",
            emailId: "shovank@gmail.com",
            contact: 9999999999
        }
    ]

    const defaultNominationState = {
        columns: [],
        courseNames: [],
        userName: "",
        showModal: false,
        tableData: [],
        filterText_: "",
        resetPaginationToggle_: false,
        validateCourseName: true,
        validateUserName: false,
        action: {},
        nominationStatus: {},
        showTable: false,
        showFinalTable: false,
        file: null,
        fileName: "",
        // validateCourseName: true,
        validateFileName: true,
        options: [],

    }
    const [getNominationData, setNominationData] = useState(defaultNominationState)

    //Api call to setOptions
    useEffect(() => {
        //load course data
        

        loadCoursesList();
    }, []);
    const loadCoursesList = () => {
        service.getPublishCourses()
            .then(res => {

                if (res.data.length !== 0) {
                    const options = res.data.map((course) => {
                        const singleCourse = {
                            id: course.courseId,
                            label: course.courseName,
                            value: course.courseName
                        }

                        return singleCourse;
                    })
                    setNominationData((prevState) => {
                        return {
                            ...prevState,
                            options: options,

                        }
                    })
                }

            }).catch((err) => {
                toast.error("Server error, Unable to fetch courses!")
            })


    }
    useEffect(() => {
        

    }, [getNominationData])

    const customTableMessages = {
        selectAll: "Select All Courses", // Change the tooltip for "Select All" here
        selectSomeItems: "Select Courses",
        allItemsAreSelected: "All courses are selected",
        searchPlaceholder: "Search course",
    };
    const options = [
        { id: "85", label: 'java', value: 'java' },
        { id: "89", label: 'python', value: 'Python' },
        { id: "70", label: '.net', value: '.Net technology' },
        // Add more options as needed
    ];

    //Data table
    // Table content Filter and Search /
    const [resetPaginationToggle, setResetPaginationToggle] =
        React.useState(false);

    const InitialColumns = [
        {
            name: "First Name",
            selector: (row) => row.firstName,
            sortable: true,
            wrap: true,

        },
        {
            name: "Last Name",
            selector: (row) => row.lastName,
            sortable: true,
            wrap: true,
        },
        {
            name: "email Id",
            selector: (row) => row.email,
            wrap: true,
            sortable: true,
        },
        // {
        //     name: "Centre Code",
        //     selector: (row) => row.centerCode,
        //     wrap: true,
        // },
        {
            name: "Contact Number",
            selector: (row) => row.mobile,
            sortable: true,
        },
        {
            name: "Status",
            selector: (row) => (
                <div>
                    {
                        getNominationData.action[row.email]?.valid ?
                            <span className='text-info font-weight-bold'>Valid</span>
                            : <span className='text-danger'>Invalid</span>

                    }
                </div>
            )

        },
        {
            name: "Action",
            wrap: true,
            cell: (row) => (
                <div>
                    {
                        getNominationData.action[row.email]?.valid ?
                            < span className='text-success font-weight-bold'><i class="fa fa-check" aria-hidden="true" style={{ fontSize: "25px" }}></i></span>
                            :
                            < span className='text-danger font-weight-bold'><i class="fa fa-times" aria-hidden="true" style={{ fontSize: "25px" }}></i></span>


                    }
                </div >
            )
        },
    ];
    //pending
    //  {        "firstName": "Vijay",        "lastName": "Yadav",   
    //      "emailId": "vijay@yopmail.com",        "mobileNo": "9212912456",       
    //  "userName": null,        "nominatedCourse": null,    
    //     "registrationStatus": "Registered",   
    //      "validationStatus": "Validated",       
    //  "nominationStatus": "Not Nominated",        "status": "Success",        "remark": null    }
    const finalColumns = [
        {
            name: "First Name",
            selector: (row) => row.firstName,
            sortable: true,
            wrap: true,

        },
        {
            name: "Last Name",
            selector: (row) => row.lastName,
            sortable: true,
            wrap: true,
        },
        {
            name: "Email Id",
            selector: (row) => row.emailId,
            wrap: true,
            sortable: true,
        },
        // {
        //     name: "Centre Code",
        //     selector: (row) => row.centerCode,
        //     wrap: true,
        // },
        {
            name: "Contact Number",
            selector: (row) => row.mobileNo,
            sortable: true,
        },
        {
            name: "Validation Status",
            selector: (row) => row.validationStatus
        },
        {
            name: "Registration Status",
            selector: (row) => row.registrationStatus

        },
        {
            name: "Nomination Status",
            selector: (row) => row.nominationStatus

        },
         {
            name: "Account Status",
            selector: (row) => row.isAccountActive

        },

    ];
    const filteredItems = getNominationData.tableData?.filter(
        (item) =>
            JSON.stringify(item).toLowerCase().indexOf(getNominationData.filterText_.toLowerCase()) !==
            -1
    );
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (getNominationData.filterText_) {
                setResetPaginationToggle(!resetPaginationToggle);

                setNominationData((prevState) => {
                    return {
                        ...prevState,
                        resetPaginationToggle_: !getNominationData.resetPaginationToggle_,
                        filterText_: ""
                    }
                });
            }
        };

        return (
            <FilterDataTable
                onFilter={(e) => { setNominationData((prevState) => { return { ...prevState, filterText_: e.target.value } }) }}
                onClear={handleClear}
                filterText={getNominationData.filterText_}
            />
        );
    }, [getNominationData.filterText_, resetPaginationToggle]);
    const customStyles = {

        title: {
            style: {
                fontColor: "red",
                fontWeight: "900",
            },
        },
        headCells: {
            style: {
                fontSize: "17px",
                fontWeight: "500",
                paddingLeft: "0 8px",
                marginLeft: "10px",
            },
        },
        cells: {
            style: {
                fontSize: "15px",
                paddingLeft: '0 8px',
                marginLeft: '10px',
                cursor: "pointer"
            },
        },
    };

    //Disabled row
    /********************Handlers section starts here ********************************************* */
    const handleMultiSelectChange = (selectedOptions) => {
        if (selectedOptions.length !== 0) {

            setNominationData((prevState) => {
                return {
                    ...prevState,
                    validateCourseName: true,
                    courseNames: [...(selectedOptions)],
                    tableData: [],
                    action: {}

                }
            })

        } else {

            setNominationData((prevState) => {
                return {
                    ...prevState,
                    validateCourseName: false,
                    courseNames: [...(selectedOptions)],
                    tableData: [],
                    action: {},
                    showTable: false


                }
            })
        }




    };
    const handlerRowClick = (row) => {

    }
    const handlerRegistrationAndNomination = () => {
        setNominationData((prevState) => {
            return {
                ...prevState,
                showModal: true,


            }
        })
        //API call to bulkUploadRegistrationAndNominations()
        setTimeout(() => {
            setNominationData((prevState) => {
                return {
                    ...prevState,
                    showTable: false,

                }
            })
            //get course ids and user data
            const listOfCourseIds = getNominationData.courseNames.map((course) => {
                return parseInt(course.id);

            });
            const listOfUserRegistrationData = Object.keys(getNominationData.action).map((singleUserEmail) => {
                return getNominationData.action[singleUserEmail]?.userData

            })
            const RegistrationData = {
                courseId: listOfCourseIds,
                learnerData: listOfUserRegistrationData
            }
            //get userID
            let userId = UserService.getUserid();
            //calling API
            service.bulkUploadRegistrationAndNominations(userId, RegistrationData)
                .then((res) => {
                    // const courseList = getNominationData.options
                    // setNominationData(defaultNominationState)
                    document.getElementById("bulk_fileName").value = ""
                    setNominationData((prevState) => {
                        return {
                            ...prevState,
                            tableData: [...(res.data)],
                            showFinalTable: true,
                            showModal: false,
                            columns: [],
                            courseNames: [],
                            userName: "",
                            // showModal: false,
                            // tableData: [],
                            filterText_: "",
                            resetPaginationToggle_: false,
                            validateCourseName: true,
                            validateUserName: false,
                            action: {},
                            nominationStatus: {},
                            showTable: false,
                            // showFinalTable: false,
                            file: null,
                            fileName: "",
                            // validateCourseName: true,
                            validateFileName: true,
                           

                        }
                    })
                    toast.success(res.data?.length + " Users Registered and Nominated Successfully!")
                })
                .catch((err) => {
                    setNominationData((prevState) => {
                        return {
                            ...prevState,
                           showModal: false
                        }
                    })
                    toast.error("Server Error!")
                })
        }, [2000])
    }
    const handleFileUpload = (event) => {

        const fileName = event.target.files[0]?.name;
        const fileExtension = fileName?.split('.').pop();
        if (fileExtension === 'xls' || fileExtension === 'xlsx') {
            setNominationData((prevState) => {
                return {
                    ...prevState,
                    validateFileName: true,
                    fileName: fileName,
                    file: event.target.files[0]
                }
            })
        }
        else {
            setNominationData((prevState) => {
                return {
                    ...prevState,
                    validateFileName: false,
                    fileName: "",
                    file: null
                }
            })

        }
        //console.log(fileExtension);

    }
    const handleBulkUpload = () => {
        

        const courseIds = getNominationData.courseNames.map((course) => {
            return course.id;

        });
        //validations
        if (getNominationData.courseNames.length === 0) {
            setNominationData((prevState) => {
                return {
                    ...prevState,
                    courseNames: [],
                    validateCourseName: false,

                }
            })
        }
        if (getNominationData.fileName === "") {
            setNominationData((prevState) => {
                return {
                    ...prevState,
                    validateFileName: false

                }
            })
        }
        //service call
        if (getNominationData.courseNames.length !== 0 && getNominationData.validateFileName && getNominationData.fileName !== "") {
            setNominationData((prevState) => {
                return {
                    ...prevState,
                    showModal: true,


                }
            })

            setTimeout(() => {
                //Fetching data 
                let reader = new FileReader()
                reader.readAsArrayBuffer(getNominationData.file)
                reader.onload = (e) => {
                    const excelData = e.target.result
                    const workBook = XLSX.read(excelData, { type: 'buffer' })
                    const workSheetName = workBook.SheetNames[0]
                    const workSheet = workBook.Sheets[workSheetName]
                    const excelJSON = XLSX.utils.sheet_to_json(workSheet)

                    const userEmailIds = excelJSON.map((singleUser) => {
                        //OTHER VALIDATION PENDING
                        const nameRegex = /^[A-Za-z. ]+$/;
                        const emailRegex = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
                        const contactRegex = /^\d{10}$/;
                        const centerList = ["BLK", "CH", "DL", "HY", "KL", "MB", "ML", "ND", "PN", "PT", "SL", "TR"]
                        let valid = true;
                        if (!emailRegex.test(singleUser.email)) valid = false;
                        if (!nameRegex.test(singleUser.lastName)) valid = false;
                        if (!nameRegex.test(singleUser.firstName)) valid = false;
                        if (!contactRegex.test(singleUser.mobile)) valid = false;
                        // if (!centerList.includes(singleUser.centerCode)) valid = false;
                        if (valid) {
                            setNominationData((prevState) => {
                                return {
                                    ...prevState,
                                    action: {
                                        ...prevState.action,
                                        [singleUser.email]: {
                                            valid: true,
                                            userData: singleUser
                                        }
                                    }
                                }
                            })
                        }
                    })
                    setNominationData((prevState) => {
                        return {
                            ...prevState,
                            tableData: excelJSON,

                        }
                    })

                    //Multiple search api

                }
                setNominationData((prevState) => {
                    return {
                        ...prevState,
                        showModal: false,
                        showTable: true
                    }
                })

            }, [2000])

        }
        //console.log("in file", getNominationData.tableData);


    }
    /********************Handlers section ends here ********************************************* */




    return (
        <Styles>

            <div className="container-scroller">
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                {
                    getNominationData.showModal &&
                    <div className='modal-loader'>
                        <Modal showModal={getNominationData.showModal} />
                    </div>

                }

                <Navbar />
                <StickyMenu />

                <div className="container-fluid page-body-wrapper">
                    <Sidebar />
                    <div className="main-panel">
                        <div className="content-wrapper">

                            <div>
                                <div className="page-header">
                                    <h3 className="page-title">
                                        Bulk User Registration & Nomination  For Courses
                                    </h3>
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item"><a href="!#" onClick={event => event.preventDefault()}>Users Nomination</a></li>
                                            <li className="breadcrumb-item active" aria-current="page">Bulk User Registration & Nomination</li>
                                        </ol>
                                    </nav>
                                </div>

                            </div>
                            <div className=''>
                                {/* search section */}
                                <Row className='d-flex  w-100 px-4  bg-light py-4 ' lg={12}>
                                    {/* <Col className='p-2 ' lg={6}>
                                        <Form.Group className=' p-0' as={Col} controlId="formGridState">
                                            <Form.Select name='courseNames' className='w-100 p-2' defaultValue="Select course" handlerUserNameChange={(event) => { handlerUserNameChange(event); }}>
                                                <option>Select course</option>
                                                <option>...</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col> */}
                                    <Col className='p-2 m-2'>

                                        <MultiSelect
                                            options={getNominationData.options}
                                            value={getNominationData.courseNames}
                                            onChange={handleMultiSelectChange}
                                            name="courseNames"
                                            labelledBy="SelectAll"
                                            overrideStrings={customTableMessages}
                                            className={`custom-multiselect  ${getNominationData.validateCourseName ? "" : "border border-danger"}`}
                                        />
                                        {!getNominationData.validateCourseName && <span className='text-danger'>Select atleast one  course</span>}
                                    </Col>
                                    {/* <Col className='p-2 ' lg={6}>

                                        <InputGroup className=" p-0 mb-2 ">
                                            <Form.Control
                                                placeholder="Search for names"
                                                aria-label="Search for names"
                                                aria-describedby="basic-addon2"
                                                name='userName'
                                                value={getNominationData.userName}
                                                onChange={(event) => { handlerUserNameChange(event); }}
                                                className={`p-4 ${getNominationData.validateUserName ? "border border-danger" : ""}`}

                                            />
                                            <Button variant="outline-success" id="search" onClick={handlerFormSubmit}>
                                                <Tooltip placement="top" className="in" id="tooltip-top">
                                                    search
                                                </Tooltip>
                                                <i class="fa fa-search fa-sm " aria-hidden="true"></i>
                                                <span className='pl-2'>Search</span>
                                            </Button >
                                        </InputGroup>
                                        {getNominationData.validateUserName && <span className='text-danger'>Please enter valid user name, Sholdn't contain any special characters  </span>}

                                    </Col> */}
                                    <Col lg={12}>
                                        <div className='bg-white my-2 p-3 border rounded text-justify w-100'>
                                            <Row className="w-100 d-flex flex-column-reverse border-bottom mx-2 mb-2 flex-lg-row" lg={12}>

                                                <Col className='d-flex flex-column py-2 mb-2 text-justify' lg={8}>
                                                    <strong className='mb-2 text-dark'>Instructions for bulk user nominations:</strong>
                                                    <span> 1. Use the Excel template provided at the right hand side.</span>
                                                    <span> 2. It is Recommended to upload 250 user records at a time to avoid slow nominations.</span>
                                                </Col>
                                                <Col className='w-100 py-2' lg={3}>
                                                    <InputGroup className=" p-0 m-0  w-100 rounded">
                                                        <a href={downloadXlFile}>
                                                            <Button className='w-100 rounded' variant="info" id="template">

                                                                <i className="fa fa-download fa-lg" aria-hidden="true"><small className='pl-1' >Download the template</small></i>

                                                            </Button >
                                                        </a>
                                                    </InputGroup>
                                                </Col>

                                            </Row>
                                            <Row className="d-flex flex-column" lg={12}>
                                                <Col className=' py-2' lg={4}>
                                                    <input id="bulk_fileName" name='fileName' type="file" onChange={(e) => { handleFileUpload(e); }} className={`p-2 rounded border w-100 ${getNominationData.validateFileName ? "" : 'border-danger'}`} />
                                                    {getNominationData.validateFileName !== true && <span className='mt-2 text-danger'>Select correct file type</span>}
                                                </Col>
                                                <Col className=' py-2' lg={4}>
                                                    <InputGroup className=" p-0 m-0 w-100 rounded">
                                                        <Button className='w-100 rounded' variant="success" id="template" onClick={handleBulkUpload}>
                                                            <i className="fa fa-upload fa-lg" aria-hidden="true"><small className='pl-1'>Bulk User Upload</small></i>
                                                        </Button >
                                                    </InputGroup>
                                                </Col>
                                            </Row>


                                        </div>
                                    </Col>
                                </Row>



                                {
                                    getNominationData.showTable &&
                                    <Row className=" w-100 px-4 py-2 pb-4 bg-light grid-margin stretch-card  border-bottom" lg={12}>
                                        <div className="card">
                                            <div className="card-body">
                                                {
                                                    getNominationData.showTable ?
                                                        <>
                                                            {
                                                                Object.keys(getNominationData.action).length !== 0 &&
                                                                <div class="alert alert-info" role="alert">
                                                                    <strong>{Object.keys(getNominationData.action).length}</strong> users selected for nomination
                                                                </div>


                                                            }
                                                            {
                                                                Object.keys(getNominationData.action).length === 0 && getNominationData.tableData.length !== 0 &&
                                                                <div class="alert alert-warning" role="alert">
                                                                    Click on a Row to Select User!
                                                                </div>
                                                            }
                                                            <DataTable
                                                                columns={InitialColumns}
                                                                data={filteredItems}
                                                                defaultSortField="Name"
                                                                defaultSortAsc={true}
                                                                striped
                                                                pagination
                                                                highlightOnHover
                                                                customStyles={customStyles}
                                                                subHeader
                                                                subHeaderComponent={subHeaderComponent}
                                                                onRowClicked={handlerRowClick}
                                                            />
                                                            <Col className='p-2' lg={6}>
                                                                <Button onClick={handlerRegistrationAndNomination} className='' variant='success' id="nominate" name='nominated'  >
                                                                    Register & Nominate
                                                                </Button>
                                                            </Col>
                                                        </>

                                                        :
                                                        <div class="alert alert-info" role="alert">
                                                            No records to display, click on Bulk upload
                                                        </div>

                                                }

                                            </div>
                                        </div>
                                    </Row>
                                }
                                {
                                    getNominationData.showFinalTable &&
                                    <Row className=" w-100 px-4 py-2 pb-4 bg-light grid-margin stretch-card  border-bottom" lg={12}>
                                        <div className="card">
                                            <div className="card-body">
                                                {
                                                    getNominationData.showFinalTable ?
                                                        <>


                                                            {
                                                                <div class="alert alert-success" role="alert">
                                                                    Users Registered and Nominated Successfully!
                                                                </div>
                                                            }
                                                            <DataTable
                                                                columns={finalColumns}
                                                                data={filteredItems}
                                                                defaultSortField="Name"
                                                                defaultSortAsc={true}
                                                                striped
                                                                pagination
                                                                highlightOnHover
                                                                customStyles={customStyles}
                                                                subHeader
                                                                subHeaderComponent={subHeaderComponent}
                                                                onRowClicked={handlerRowClick}
                                                            />

                                                        </>

                                                        :
                                                        <div class="alert alert-info" role="alert">
                                                            No records to display, click on Bulk upload
                                                        </div>

                                                }

                                            </div>
                                        </div>
                                    </Row>
                                }


                            </div>
                            <SettingsPanel />
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>

        </Styles>
    )
}

export default BulkUsersRegistrationNomination
